import * as React from 'react'
import { CortexDecoderProvider, CortexVideo } from 'lib/scanner/compatibility'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { ScanbotVideo } from 'lib/scanner/scanbot/ScanbotVideo'

export function SingleScanProvider({
  children,
  canScan = true,
  isTrayScan = false,
}: {
  children: React.ReactNode
  canScan: boolean
  isTrayScan?: boolean
}) {
  const [currentScan, setCurrentScan] = React.useState<
    CortexDecoder.CDResult | undefined
  >()
  const flags = useFlags()
  const useScanbotSDK = flags.useScanbotSdk

  const returnOnDisabledScan = () => {
    return
  }

  return (
    <CortexDecoderProvider
      canScan={canScan}
      onScan={canScan ? setCurrentScan : returnOnDisabledScan}
      currentScan={currentScan}
      setCurrentScan={setCurrentScan}
      isTrayScan={isTrayScan}
    >
      {useScanbotSDK ? <ScanbotVideo /> : <CortexVideo />}
      {children}
    </CortexDecoderProvider>
  )
}
